let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fbn5L")).then(() => parcelRequire('C9929'));